import { BaseCommand } from './commands';
import { ESimSmartDetailedBarUnbarCommand } from './ESimSmartDetailedBarUnbarCommand';

export class ESimSmartDetailedBarCommand extends ESimSmartDetailedBarUnbarCommand {
  public definitionAlias: 'esimsmart-detailed-bar' = 'esimsmart-detailed-bar';
  constructor(command: BaseCommand) {
    super(command);
  }
}
